import React from 'react';

const Logo = () => {
    return (
        <div id="logo">
            <h1 className="text-center pb-4">Ticker App</h1>
        </div>
    )
}

export default Logo;